<template>
  <label for="">{{ t[state.title.replace(/lang\.mobile(_ml)?\.?/g, '')] || data.title }}</label>
  <p>{{ data.hasAutoComplete ? `${translateText('hubstr.editor.phone_preview.text')} 1, ${translateText('hubstr.editor.phone_preview.text')} 2` : translateText('hubstr.editor.phone_preview.text') }}</p>
  <el-divider />
</template>

<script lang="ts" setup>
import {
  reactive,
} from 'vue';
import { TranslatesAssociationList as t } from 'features/settings/editor/association-editor/requests';
import { translate, useTranslate } from 'magner';
import {
  ITextSectionWidget,
} from 'features/settings/editor/association-editor/ui/components/left-side/components/widgets/types/interfaces';
import { formatShortDate } from '~/utils/format-date';

interface Props {
  data: ITextSectionWidget;
}

const props = defineProps<Props>();

const state = reactive({
  ...props.data,
  text: props.data.name === 'date' ? formatShortDate(props.data.value?.date) : props.data.text,
});

const { customT } = useTranslate();
const translateText = (code: string) => customT(translate(code));

</script>

<style scoped>
label {
  color: #8A8A8F;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: -0.016em;
}
.el-divider--horizontal {
  margin: 0 0 15px 0;
}
</style>
